import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

function AnimateOnMount({
    children,
    className,
    duration,
    ease,
    from,
    style,
    to,
}) {
    const [entered, setEntered] = useState(false);

    useEffect(() => {
        const id = requestAnimationFrame(() => {
            setEntered(true);
        });

        return () => cancelAnimationFrame(id);
    }, []);

    return (
        <div
            className={className}
            style={{
                ...style,
                ...(entered ? to : from),
                transition: `all ${duration}ms ${ease}`,
            }}
        >
            {children}
        </div>
    );
}

AnimateOnMount.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
    className: PropTypes.string,
    duration: PropTypes.number,
    ease: PropTypes.string,
    from: PropTypes.shape({
        opacity: PropTypes.string,
        transform: PropTypes.string,
    }),
    style: PropTypes.shape({}),
    to: PropTypes.shape({
        opacity: PropTypes.string,
        transform: PropTypes.string,
    }),
};

AnimateOnMount.defaultProps = {
    className: '',
    duration: 300,
    ease: 'ease-in',
    from: {
        opacity: 0,
        transform: 'translateY(8px)',
    },
    style: {},
    to: {
        opacity: 1,
        transform: 'translateY(0)',
    },
};

export default AnimateOnMount;
